"use client";

import { useFetchApi } from "@/composables/useFetchApi";
import type { StrapiCollectionResponse, StrapiEntity, StrapiQuery, StrapiQueryValue } from "@/lib/strapi";
import type { ArticleAttributes } from "@/services/article";

export type UseArticlesOptions = {
  enabled?: boolean;
  query?: StrapiQuery;
  populate?: StrapiQueryValue;
  pageSize?: number;
  withBrandFilter?: boolean;
  path?: string;
  initialData?: StrapiCollectionResponse<ArticleAttributes> | null;
};

export function useArticles(options?: UseArticlesOptions) {
  const query: StrapiQuery = {
    ...(options?.query ?? {}),
    filters: {
      ...(typeof options?.query?.filters === "object" && options?.query?.filters !== null
        ? (options.query.filters as Record<string, unknown>)
        : {}),
      active: { $eq: true },
    },
    sort: options?.query?.sort ?? ["date:desc", "updatedAt:desc"],
    pagination: {
      ...(typeof options?.query?.pagination === "object" && options?.query?.pagination !== null
        ? (options.query.pagination as Record<string, unknown>)
        : {}),
      pageSize: options?.pageSize ?? 3,
    },
    populate:
      options?.populate !== undefined
        ? options.populate
        : (options?.query?.populate ?? {
            image_thumbnail: { populate: "*" },
            image: { populate: "*" },
            article_category: { populate: "*" },
          }),
  };

  const state = useFetchApi<StrapiCollectionResponse<ArticleAttributes>>(options?.path ?? "/articles", {
    enabled: options?.enabled,
    query,
    withBrandFilter: options?.withBrandFilter ?? true,
    initialData: options?.initialData,
    cacheTtlMs: 3600_000,
  });

  const articles: Array<StrapiEntity<ArticleAttributes>> = state.data?.data ?? [];

  return { ...state, articles };
}
